import { Button, Col, Form, Modal, Row, Toast,PinCode,Typography } from "@douyinfe/semi-ui";
import {IconKey, IconModalStroked, IconUser, IconUserCardPhone, IconComment} from "@douyinfe/semi-icons";
import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import { ApiClient, LogInReq, User } from "../../api/ApiClient";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { useNavigate } from "react-router-dom";
import { meetRoles } from "../../utils";
import "./index.css";

const apiClient = ApiClient.getDefault();
let logInDto = {} as LogInReq;
let captchaApi: FormApi;
export default function Login() {
  const [countdown, setCountdown] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loginType, setLoginType] = useState("password");
  const [switchLoginType, setSwitchLoginType] = useState(false);
  const [pinCode, setPinCode] = useState("");
  
  let captchaImageSrc = () => `${apiClient.endpoint + "/auth/captcha"}`;
  let userNameValidator = (
    values: Record<string, any>
  ): string | Record<string, any> => {
    let errors: Record<string, any> = {};
    if (!values["mobile"]) {
      errors["mobile"] = "请填写手机号";
    }
    if (!values["password"]) {
      errors["password"] = "请填写密码";
    }
    return Object.keys(errors).length === 0 ? "" : errors;
  };

  let captchaValidator = (
    values: Record<string, any>
  ): string | Record<string, any> => {
    let errors: Record<string, any> = {};
    if (!values.captcha) {
      errors.captcha = "请填写验证码";
    }
    return Object.keys(errors).length === 0 ? "" : errors;
  };
  let nav = useNavigate();
  let [captchaVisible, setCaptchaVisible] = useState(false);
  let [submitting, setSubmitting] = useState(false);
  let [captchaImage, setCaptchaImage] = useState("");
  let captchaRef = useRef<HTMLImageElement>(null);

  let fetchCaptcha = async () => {
    setSubmitting(true);
    try {
      let captchaImage = await apiClient.getCaptchaImage();
      setCaptchaImage(captchaImage);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
    }
  };
  let handleUsernameSubmit = async (values: Record<string, any>) => {
    logInDto.mobile = values.mobile;
    logInDto.password = values.password;
    setCaptchaVisible(true);
    fetchCaptcha();
  };

  let getDefaultMenuKey = (admin: User) => {
    for (var i = 0; i < admin.menus.length; i++) {
      if (admin.menus[i].menus && admin.menus[i].menus.length > 0) {
        return admin.menus[i].menus[0].code;
      }
    }
  };

  let handleCaptchaSubmit = async (values: Record<string, any>) => {
    await captchaApi.validate();
    logInDto.captcha = captchaApi.getValue("captcha");
    logInDto.otp = captchaApi.getValue("otp");
    setSubmitting(true);

    try {
      await apiClient.logIn(logInDto);
      let user = await apiClient.getCurrentAdmin();
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);
      if("zhangtao" === user.data.username){
          localStorage.setItem("loginFrom", user.data.username);
      } else{
          localStorage.setItem("loginFrom", "");
      }
      
      let page = getDefaultMenuKey(user.data);
      console.log("page ", "login");
      nav("/" + page, { replace: true });
    } catch (e) {
      console.error("登录错误", e);
      // let msg = (e as Error).message;
      // if (msg != "无效验证码") {
      //   setCaptchaVisible(false);
      // } else {
      //   fetchCaptcha();
      // }
      // setSubmitting(false);
      //刷新页面
      setTimeout(() => { window.location.reload(); }, 2000);
    }
  };

  let handleCaptchaCancel = (values: Record<string, any>) => {
    setCaptchaVisible(false);
    setSubmitting(false);
  };

  let handleCaptchaImageClick = async () => {
    if (submitting) {
      return;
    }
    fetchCaptcha();
  };

  useEffect(() => {
    //获取浏览器访问地址的IP
    let ip = window.location.host;
    console.log("ip:", ip);
    if( ip.includes("47.109.154.206")){//成都系统
      setLoginType("sms");
      setSwitchLoginType(false);
    }else{
      setLoginType("password");
      setSwitchLoginType(false);
    }
    apiClient.setToken("");
    apiClient.initToken();
  }, []);


  let sendCaptcha = async () => {
    let mobile = captchaApi.getValue("mobile");
    if (!mobile) {
      Toast.info('请输入手机号');
      return;
    }

    try {
      setIsLoading(true);
      const ret: any = await apiClient.request('/auth/sendCaptcha?mobile=' + mobile, 'POST', null, null);
      if ("ok" == ret.code) {
        setCountdown(60); // 60秒倒计时
        Toast.success('验证码已发送');
      }

    } catch (error) {
      Toast.error('发送验证码失败');
    } finally {
      setIsLoading(false);
    }
  };

  let handleSmsLoginSubmit = async (smsCode?: string) => {
    let code = smsCode?smsCode:pinCode;
    logInDto.captcha = code;
    logInDto.mobile = captchaApi.getValue("mobile");
    if (!logInDto.mobile) {
      Toast.info('请输入手机号');
      return;
    }
    if (!logInDto.captcha) {
      Toast.info('请输入短信验证码');
      return;
    }
    setSubmitting(true);

    try {
      await apiClient.logInSms(logInDto);
      let user = await apiClient.getCurrentAdmin();
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);
      let page = getDefaultMenuKey(user.data);
      console.log("page ", "login");
      nav("/" + page, { replace: true });
    } catch (e) {
      console.error("登录错误", e);
      // let msg = (e as Error).message;

      // setSubmitting(false);
      //刷新页面
      setTimeout(() => { window.location.reload(); }, 2000);
       
    }
  };



  let form;
  if(loginType === 'password'){
   form =
   (
    <div className="login-form">
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        hasCancel={false}
        confirmLoading={submitting}
        title="请输入验证码"
        visible={captchaVisible}
        onOk={handleCaptchaSubmit}
        style={{ width: 500 }}
        onCancel={handleCaptchaCancel}
      >
        <Form
          validateFields={captchaValidator}
          getFormApi={(api) => (captchaApi = api)}
        >
          <Form.Input
            className="el-input"
            placeholder="验证码 (点击可刷新)"
            noLabel={true}
            addonBefore={
              <img
                ref={captchaRef}
                onClick={handleCaptchaImageClick}
                className="captcha-image"
                src={captchaImage}
              />
            }
            trigger="blur"
            field="captcha"
            onEnterPress={handleCaptchaSubmit}
          />
          {/* <Form.InputNumber
            className="el-input"
            maxLength={6}
            style={{ width: "100%" }}
            placeholder="6位验证器密码，有验证器必填"
            noLabel={true}
            trigger="blur"
            field="otp"
          />*/}
        </Form> 
      </Modal>

      <div className="title">你好 !</div>
      <div className="title-tips">欢迎来到CRM客户管理系统！</div>
      <Form
        onSubmit={handleUsernameSubmit}
        validateFields={userNameValidator}
        render={({ formState, formApi, values }) => (
          <>
            <Form.Section text="账号密码登录">
              <Form.Input
                className="el-input"
                prefix={<IconUser />}
                trigger="blur"
                field="mobile"
                label="手机号"
                style={{ width: "350px" }}
              />
              <Form.Input
                className="el-input"
                prefix={<IconKey />}
                type="password"
                field="password"
                label="密码"
                style={{ width: "350px" }}
              />
              <div className="login-form-footer">
                <Button
                  style={{ width: "350px" }}
                  type="primary"
                  htmlType="submit"
                  theme="solid"
                  className="btn-margin-right"
                >
                  登录
                </Button>
              </div>

              {switchLoginType && <div className="login-form-login-switch">
                <Button
                  type="secondary"
                  theme="borderless"
                  size="large"
                  onClick={()=>setLoginType("sms")}
                >
                  使用短信验证码登录
                </Button>
              </div>
             }
            </Form.Section>
          </>
        )}
      ></Form>
    </div>
  );
  }else{
   form = (
    <div className="login-form">
      <div className="title">你好 !</div>
      <div className="title-tips">欢迎来到CRM客户管理系统！</div>
      <Form
        getFormApi={(api) => (captchaApi = api)}
        render={({ formState, formApi, values }) => (
          <>
            <Form.Section text="短信验证码登录">
              <Form.Input
                className="el-input"
                prefix={<IconUserCardPhone  />}
                trigger="blur"
                field="mobile"
                label="手机号"
                style={{ width: '350px' }}
              />
              <div className="form-group captcha-group">
                {/* <Form.InputNumber
                  hideButtons
                  className="el-input"
                  prefix={<IconComment  />}
                  type="number"
                  field="captcha"
                  label="短信验证码"
                  style={{ width: '250px' }}
                /> */}
        
                <Form.Slot label={{ text: '短信验证码' }} >
                <PinCode format={'number'} onComplete={value =>{
                    setPinCode(value);
                    console.log('pincode: ', value);
                    handleSmsLoginSubmit(value);
                  }
                } 
                />
                </Form.Slot>

                <Button
                  theme="outline"
                  style={{marginLeft: '10px', marginBottom: '9px' }}
                  onClick={sendCaptcha}
                  disabled={countdown > 0 || isLoading}
                >
                  {countdown > 0 ? `${countdown}秒后重试` : '获取验证码'}
                </Button>
              </div>
              <div className="login-form-footer">
                <Button
                  style={{ width: "350px" }}
                  type="secondary"
                  htmlType="submit"
                  theme="solid"
                  size="large"
                  loading={submitting}
                  onClick={() => handleSmsLoginSubmit()}
                >
                  登录
                </Button>
              </div>

              {switchLoginType &&<div className="login-form-login-switch">
                <Button
                  type="secondary"
                  theme="borderless"
                  size="large"
                  onClick={()=>setLoginType("password")}
                >
                  使用密码登录
                </Button>
              </div>
              }
            </Form.Section>
          </>
        )}
      ></Form>
    </div>
  );
}

  return (
    <div className="grip login-container">
      <Row>
        <Col lg={16} md={12} sm={24} xl={16} xs={24}></Col>
        <Col lg={8} md={12} sm={24} xl={8} xs={24}>
          {form}
        </Col>
      </Row>
    </div>
  );
}
